/* Thème Shestia, sh-collection-panels (ACCUEIL-1, 02/10/2026). Écrit de zéro.
   Relevé (reference/accueil-1/paliers.json, dom-collection-panels-390.json) : un panneau par vue au téléphone, deux de
   768 px, 1 px entre eux ; flèches au téléphone seulement, 0,35 d'opacité à l'extrémité ; pas de boucle. */
(function () {
  'use strict';
  if (customElements.get('sh-collection-panels')) return;

  class ShCollectionPanels extends HTMLElement {
    connectedCallback() {
      // Mise en place différée, comme la référence (accueil-2/lookbook_hauteur_390.py sur collection_panels, 03/10) :
      // tant que la section est à plus de ~300 px sous l'écran, le carrousel n'est pas monté et chaque panneau prend
      // toute la largeur (1 161,38 px de haut à 1440, 841,48 à 1024) ; bascule relevée entre 285 et 295 px sous l'écran,
      // donc hors de la vue. Au téléphone, un panneau par vue : même hauteur avant et après.
      const lancer = () => {
        if (!('IntersectionObserver' in window)) { this.init(); return; }
        this.io = new IntersectionObserver((entrees) => {
          entrees.forEach((en) => {
            if (!en.isIntersecting) return;
            if (this.io) { this.io.disconnect(); this.io = null; }
            this.init();
          });
        }, { rootMargin: '0px 0px 300px 0px' });
        this.io.observe(this);
      };
      if (window.Swiper) lancer();
      else window.addEventListener('DOMContentLoaded', lancer, { once: true });
    }

    init() {
      if (this.swiper || !window.Swiper) return;
      this.swiper = new window.Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 1,
        speed: 500,
        watchOverflow: true,
        navigation: {
          prevEl: this.querySelector('.sh-cpan__arrow--prev'),
          nextEl: this.querySelector('.sh-cpan__arrow--next')
        },
        breakpoints: { 768: { slidesPerView: 2, spaceBetween: 1, allowTouchMove: false } }
      });
    }

    disconnectedCallback() {
      if (this.io) { this.io.disconnect(); this.io = null; }
      if (this.swiper) { this.swiper.destroy(true, true); this.swiper = null; }
    }
  }

  customElements.define('sh-collection-panels', ShCollectionPanels);
})();
